module.exports = __webpack_public_path__ + "assets/img/Slice 164(7).c8427bc0.png";